import { useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import progressBar from '../lib/progressBar';
import '../styles/TopProgressBar.css';

const TopProgressBar = () => {
  const [value, setValue] = useState(0);
  const location = useLocation();
  const prevPath = useRef(location.pathname);

  // Subscribe to the singleton controller
  useEffect(() => {
    return progressBar.subscribe(setValue);
  }, []);

  // Trigger progress on route change
  useEffect(() => {
    if (location.pathname !== prevPath.current) {
      prevPath.current = location.pathname;
      progressBar.start();
      // Route component will call done() implicitly via Suspense resolve,
      // but we add a safety timeout for fast routes that resolve instantly.
      const t = setTimeout(() => progressBar.done(), 600);
      return () => clearTimeout(t);
    }
  }, [location.pathname]);

  const visible = value > 0 && value < 1;
  const finishing = value === 1;

  return (
    <div
      className={`top-progress-bar ${visible ? 'visible' : ''} ${finishing ? 'finishing' : ''}`}
      role="progressbar"
      aria-valuenow={Math.round(value * 100)}
    >
      <div
        className="top-progress-bar__fill"
        style={{ transform: `scaleX(${value})` }}
      />
    </div>
  );
};

export default TopProgressBar;
